<template>
<div class="chapter">
<div class="inner_page">
<a id="piv"></a>
<div class="copyright">
<p class="left ">Copyright © 2010 by Thomas H. Cook</p>
<div class="timebreak "> </div>
<p class="left "><span class="smallcaps">ALL RIGHTS RESERVED</span></p>
<div class="timebreak "> </div>
<p class="left ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="left "><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="left "><em>The Library of Congress has cataloged the print edition as follows:</em>
<br/>Cook, Thomas H.
<br/>The last talk with Lola Faye / Thomas H. Cook.
<br/>p. cm.
<br/><span class="smallcaps">ISBN</span> 978-0-15-101407-1
<br/>1. Murder victims’ families—Fiction. 2. Crimes of passion—Fiction. 3. Psychological fiction. I. Title.
<br/><span class="smallcaps">PS</span>3553.055465<span class="smallcaps">L</span>37 2010
<br/>813'.54—dc22 2009027927</p>
<div class="timebreak "> </div>
<p class="left ">e<span class="smallcaps">ISBN</span> 978-0-547-54127-3</p>
<p class="left ">v2.1116</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?79f3e368